module.exports = __webpack_public_path__ + "static/media/Brighton 1st.886f6af5.jpg";